<div class="modal-overlay">
  <div class="modal-content">
    <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="closeModal()">
      &times;
    </button>

    <div class="modal-body">
      <div class="modal-header">
        <h2>{{ mode === 'edit' ? ('renter.modalEditTitle' | t:'Edit Renter') : ('renter.modalNewTitle' | t:'New Renter') }}</h2>
      </div>

      <form [formGroup]="renterForm" (ngSubmit)="onSubmit()">
        <div class="form-grid">
          <div class="form-group">
            <label>{{ 'renter.name' | t:'Name' }} *</label>
            <input type="text" formControlName="renterName" [placeholder]="'placeholder.typeRenterName' | t:'Type renter name'" />
          </div>

          <div class="form-group">
            <label>{{ 'renter.mobile' | t:'Mobile' }} *</label>
            <div class="mobile-input-wrap">
              <span class="mobile-prefix">{{ mobilePrefix }}</span>
              <input
                type="tel"
                inputmode="numeric"
                formControlName="renterMobile"
                [placeholder]="'placeholder.typeMobileNumber' | t:'Type mobile number'"
                (blur)="normalizeMobileInput()"
              />
            </div>
            <div class="field-error" *ngIf="renterForm.get('renterMobile')?.touched && renterForm.get('renterMobile')?.hasError('required')">
              Mobile number is required.
            </div>
            <div class="field-error" *ngIf="renterForm.get('renterMobile')?.touched && renterForm.get('renterMobile')?.hasError('pattern')">
              Enter a valid mobile number.
            </div>
          </div>

          <div class="form-group">
            <label>{{ 'renter.email' | t:'Email' }}</label>
            <input type="email" formControlName="renterEmail" [placeholder]="'placeholder.typeRenterEmail' | t:'Type renter email'" />
          </div>

          <div class="form-group">
            <label>{{ 'renter.photoIdNo' | t:'NID/Birth Reg No' }}</label>
            <input type="text" formControlName="renterPhotoIdNo" [placeholder]="'placeholder.typePhotoIdNumber' | t:'Type NID/Birth Reg no'" />
          </div>

          <div class="form-group full-width">
            <label>{{ 'renter.permanentAddress' | t:'Permanent Address' }} *</label>
            <input type="text" formControlName="renterPermanentAddress" [placeholder]="'placeholder.typePermanentAddress' | t:'Type permanent address'" />
          </div>

          <div class="form-group full-width">
            <label>{{ 'renter.previousAddress' | t:'Previous Address' }} *</label>
            <input type="text" formControlName="renterPreviousAddress" [placeholder]="'placeholder.typePreviousAddress' | t:'Type previous address'" />
          </div>
        </div>

        <div class="form-actions">
          <div class="form-message error" *ngIf="error">{{ error }}</div>
          <button
            *ngIf="mode === 'edit'"
            type="button"
            class="DocumentUpdateBTN"
            (click)="openDocumentUpdate()"
          >
            {{ 'renter.imageUpdate' | t:'Renter Image Update' }}
          </button>
          <button class="PositiveBTN" type="submit" [disabled]="isSubmitting">
            {{ isSubmitting ? ('common.saving' | t:'Saving...') : (mode === 'edit' ? ('renter.updateButton' | t:'Update Renter') : ('renter.addButton' | t:'Add Renter')) }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
